export class OnePager {
    private pageOffsets: Record<string, number> = {};
    private scrollTargets: NodeListOf<Element>;
    private navLinks: NodeListOf<Element>;
    private headerHeight: number;
    private resizeTimeout: number;
    private scrollTimeout: number;

    constructor() {
        this.scrollTargets = document.querySelectorAll('.scroll-target');
        this.navLinks = document.querySelectorAll('.mainnav a[data-target]');
        this.setSizes();
        this.calculateActiveMainnav();

        window.addEventListener('resize', () => {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => {
                this.setSizes();
                this.calculateActiveMainnav();
            }, 500);
        });

        document.addEventListener('scroll', () => {
            clearTimeout(this.scrollTimeout);
            this.calculateActiveMainnav();
        });

        document.querySelectorAll('a[href^="#"]').forEach((link: HTMLAnchorElement) => {
            link.addEventListener('click', e => {
                const anchor = (e.target as HTMLElement).closest('a');
                const id = anchor.href.split('#')[1];
                window.history.pushState({ onepager: id }, '', `#${id}`);
            });
        });
    }

    private calculateActiveMainnav(): void {
        let activeFound = false;
        const reversedPageOffsets = Object.keys(this.pageOffsets).reverse();

        // if scrolled to end set active for last element (used if last element is not high enough)
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
            this.setMainnavActive(reversedPageOffsets[0]);
            activeFound = true;
        } else {
            for (const id of reversedPageOffsets) {
                if (this.pageOffsets[id] <= window.scrollY + this.headerHeight + 10) {
                    this.setMainnavActive(id);
                    activeFound = true;
                    break;
                }
            }
        }

        if (!activeFound) {
            this.resetMainNav();
        }
    }

    private setSizes(): void {
        this.scrollTargets.forEach(page => {
            this.pageOffsets[page.id] = this.getTopOffset(page);
        });

        this.headerHeight = document.getElementById('header').offsetHeight;
    }

    private getTopOffset(el: Element): number {
        const rect = el.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return Math.round(rect.top + scrollTop);
    }

    private setMainnavActive(id: string): void {
        const ele = Array.from(this.navLinks).find((a: HTMLAnchorElement) => !a.classList.contains('parent-link') && a.dataset.target === id);
        if (ele === null || ele.classList.contains('is-active')) {
            return;
        }

        this.resetMainNav();
        ele.classList.add('is-active');
        window.history.replaceState({ onepager: id }, '', `#${id}`);
    }

    private resetMainNav(): void {
        this.navLinks.forEach(a => {
            a.classList.remove('is-active');
        });
    }
}

declare global {
    interface Window {
        pageId: number;
    }
}

if (window.pageId === 1 && document.documentElement.classList.contains('is-onepager')) {
    const onePager = new OnePager();
}
